// Copied & Modified for TypeScript from
// https://gist.github.com/pmeenan/5902672#file-user-timing-js

declare global {
  interface Performance {
    webkitNow?: () => number
    msNow?:     () => number
    mozNow?:    () => number
  }
}

const w = typeof window !== "undefined" ? window : exports
const marks = [] as Array<{
  name:       string,
  entryType:  "mark",
  startTime:  number,
  duration:   number,
}>
w.performance = w.performance || {}
w.performance.now = w.performance.now || performance.now || performance.webkitNow || performance.msNow || performance.mozNow
if (!w.performance.now){
  let s = Date.now ? Date.now() : +(new Date())
  if (performance.timing && performance.timing.navigationStart) {
    s = performance.timing.navigationStart
  }
  w.performance.now = (() => {
    const n = Date.now ? Date.now() : +(new Date())
    return n - s
  })
}
w.performance.mark = w.performance.mark ||
  w.performance.webkitMark ||
    ((l: string) => {
      marks.push({
        name:       l,
        entryType:  "mark",
        startTime:  w.performance.now(),
        duration:   0,
      })
    })
w.performance.getEntriesByType = w.performance.getEntriesByType ||
  w.performance.webkitGetEntriesByType ||
    ((t: string) => {
      if (t === "mark") { return marks }
      // Always return array to avoid issue
      return []
    })
w.performance.measure = w.performance.measure ||
  ((name: string, startMark?: string | undefined, endMark?: string) => { /* Intentionally nothing */ })

const w_performance = w.performance

export {
  w_performance as performance,
}
